import styled from "styled-components"
import { FitlerInput } from "../../FilterStyles"

export const SearchInput = styled(FitlerInput)``